import React from 'react'
import { useDispatch } from 'react-redux';
import { IncreaseQuantity,DecreaseQuantity } from "../../redux/action/action";

export const CartButon = ({quantity,id,stock}) => {
    const quantityID = id-1
    const dispatch = useDispatch()
    const handleIncrese =(id)=>{
            dispatch(IncreaseQuantity(id))
    }
 
    const handleDecrese =(id)=>{
        dispatch(DecreaseQuantity(id))
    }
        return (
        <div className="flex flex-row space-x-2 w-full items-center rounded-lg"
         >
         {quantity<=1?null:<button onClick={()=>handleDecrese(quantityID)}
             className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M18 12H6"
                                            />
                                        </svg>
                                    </button>}
                                    <p>{quantity} </p>
                                  {quantity>=20?null:  <button  onClick={()=>handleIncrese(quantityID)}
                                        className="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-4 w-4"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                stroke-width="2"
                                                d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                            />
                                        </svg>
                                    </button>}
                                </div>
    )
}
